/**
 * Prepares rows for the order CompactTable.
 * Relies on CompactTable virtualization — do not inject padding placeholders.
 */
export default function prepareOrderTableData<
	T extends { id: number | string },
>(items: T[], hideOrderIds: Array<number | string> = []): T[] {
	if (!Array.isArray(items) || items.length === 0) return [];

	if (!hideOrderIds.length) return items;

	return items.filter((item) => !hideOrderIds.includes(item.id));
}
